module.exports = __webpack_public_path__ + "img/icon_footBall.4e35dc43.svg";